"use strict";

/* Polyfill: NodeList.forEach for old browsers */
if ("NodeList" in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (cb, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) cb.call(thisArg, this[i], i, this);
  };
}


/* ---------------------------------------
 * Globals & constants (kept minimal)
 * ------------------------------------- */

const LOGO_DEFAULT  = "/assets/svg/logo.svg";
const LOGO_SCROLLED = "/assets/svg/logo-scroll.svg";

const HEADER_EL        = document.getElementById("header");

/* Helper: safely get the <img> inside .header__logo */
function getHeaderLogoImg() {
  const logoWraps = document.getElementsByClassName("header__logo");
  if (!logoWraps || !logoWraps[0]) return null;
  const imgs = logoWraps[0].getElementsByTagName("img");
  return imgs && imgs[0] ? imgs[0] : null;
}

let lastScrollTop = 0;
let lastScrollY = window.scrollY;

/* Helper: true if this page should always load in "scrolled" mode (white logo, colored bg) */
function shouldForceScrolledHeader() {
  if (!HEADER_EL) return false;

  if (
    HEADER_EL.classList.contains("no-hero") ||
    HEADER_EL.querySelector(".no-hero")
  ) {
    return true;
  }

  return false;
}


/* ---------------------------------------
 * Utils
 * ------------------------------------- */

/** Smoothly scroll to an element by id, compensating header height. */
function animateTo(targetId) {
  const target = document.getElementById(targetId);
  if (!target) return;

  const header = HEADER_EL || document.getElementsByTagName("header")[0];
  if (!header) return;

  const from   = window.pageYOffset || window.scrollY || 0;
  const absTop = target.getBoundingClientRect().top + from;

  const isMobile = window.matchMedia("(max-width: 639px)").matches;

  let to;
  if (isMobile) {
    const headerOffset = header ? (header.clientHeight + header.offsetTop) : 0;
    to = absTop - (headerOffset - 150);
  } else {
    const r = header.getBoundingClientRect();
    // to = absTop - ((r.height + r.top) * 2);
    to = absTop - ((r.height + r.top) * 0.5);
  }

  const duration = 1400;
  const start = performance.now();

  const easeInOutQuart = function (t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  };

  function step(ts) {
    const elapsed  = ts - start;
    const progress = Math.min(elapsed / duration, 1);
    const y        = easeInOutQuart(progress) * (to - from) + from;
    window.scrollTo(0, y);
    if (elapsed < duration) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}


/** Header behavior on scroll: toggle style + swap logo (only when not forced). */
function handleHeaderOnScroll() {
  if (!HEADER_EL) return;

  const y = document.documentElement.scrollTop || window.pageYOffset || 0;
  const isScrolled = y >= 80;

  HEADER_EL.classList.toggle("scroll", isScrolled);

  const img = getHeaderLogoImg();
  if (img) {
    const desired = isScrolled ? LOGO_SCROLLED : LOGO_DEFAULT;
    if (img.getAttribute("src") !== desired) {
      img.setAttribute("src", desired);
    }
  }

  lastScrollTop = y > 0 ? y : 0;
}

/* ---------------------------------------
 * Main init (DOMContentLoaded)
 * ------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  if (HEADER_EL) {
    document.documentElement.style.setProperty( "--header-height",  (HEADER_EL.clientHeight + HEADER_EL.offsetTop) + "px");
  }
  
  const FORCE_DOWN = shouldForceScrolledHeader();

  
  if (HEADER_EL) {
    if (FORCE_DOWN) {
      HEADER_EL.classList.add("scroll");

      const img = getHeaderLogoImg();
      if (img && img.getAttribute("src") !== LOGO_SCROLLED) {
        img.setAttribute("src", LOGO_SCROLLED);
      }
    } else {
      window.addEventListener("scroll", handleHeaderOnScroll, { passive: true });
      handleHeaderOnScroll();
    }
  }

  document.querySelectorAll("p").forEach(function (p) {
    if (!p.textContent.trim()) p.remove();
  });

  // const signupIds = ["email-signup_email_address", "email-signup_first_name", "email-signup_last_name"];
  // for (let i = 0; i < signupIds.length; i++) {
  //   const el = document.getElementById(signupIds[i]);
  //   if (!el) continue;
  //   el.addEventListener("focus", function (e) {
  //     const parent = e.target.parentElement;
  //     if (parent) parent.classList.add("moved");
  //   });
  // }

  // const labelFields = document.querySelectorAll(".form-module__field input:not([type=checkbox]):not([type=radio]), .form-module__field select, .form-module__field textarea");
  // labelFields.forEach(function (field) {
  //   field.addEventListener("focus", function () {
  //     const parent = field.parentElement;
  //     if (parent) parent.classList.add("moved");
  //   });
  // });

  if (window.location.hash) {
    const id = window.location.hash.substring(1);
    animateTo(id);
  }

  const anchors = document.querySelectorAll('[href*="#"]:not([data-lbx]):not(.skip-to-content)');
  anchors.forEach(function (a) {
    const targetId = a.hash ? a.hash.substring(1) : "";
    if (!targetId || !document.getElementById(targetId)) return;
    a.addEventListener("click", function (e) {
      e.preventDefault();
      animateTo(targetId);
    });
  });



  (function layoutHeaderNav() {
    const nav  = document.querySelector(".privary-navigation__list");
    const logo = document.querySelector(".header__logo");
    if (!nav || !logo) return;

    const items = Array.prototype.slice.call(nav.children);
    const firstGroup  = items.slice(0, 4);
    const secondGroup = items.slice(4);

    const leftWrap  = document.createElement("div");
    const rightWrap = document.createElement("div");
    leftWrap.className  = "nav-left";
    rightWrap.className = "nav-right";

    for (let i = 0; i < firstGroup.length; i++)  leftWrap.appendChild(firstGroup[i]);
    for (let j = 0; j < secondGroup.length; j++) rightWrap.appendChild(secondGroup[j]);

    nav.innerHTML = "";
    nav.appendChild(leftWrap);
    nav.appendChild(rightWrap);
    nav.insertBefore(logo, rightWrap);
  })();

  (function fadeInAllContent() {
    const selectors = [
      "#gallery-flex #content"
    ];

    const seen = new Set();
    const nodes = [];
    for (let s = 0; s < selectors.length; s++) {
      const found = document.querySelectorAll(selectors[s]);
      for (let i = 0; i < found.length; i++) {
        const el = found[i];
        if (!seen.has(el)) {
          seen.add(el);
          nodes.push(el);
        }
      }
    }
    if (nodes.length === 0) return;

    for (let j = 0; j < nodes.length; j++) {
      nodes[j].style.transition = "opacity 0.5s ease";
      // nodes[j].style.opacity = "0"; // enable if you want hard fade-from-0
    }

    setTimeout(function () {
      for (let k = 0; k < nodes.length; k++) {
        nodes[k].style.opacity = "1";
      }
    }, 500);
  })();

  function isMobile() { return window.innerWidth <= 640; }

/* function convertSubmenuToCustomSelect() {
    const submenuHold = document.querySelector(".sub-menu__hold .sub-menu");
    const originalUl = submenuHold ? submenuHold.querySelector("ul") : null;
    
    if (!originalUl) return;

    const activeLink = originalUl.querySelector("a.active");
    const activeText = activeLink ? activeLink.textContent.trim() : "Select Menu";

    const customSelectWrapper = document.createElement("div");
    customSelectWrapper.className = "custom-submenu-select";

    const trigger = document.createElement("div");
    trigger.className = "custom-submenu-trigger";
    trigger.innerHTML = `<span>${activeText}</span> <i class="arrow"></i>`;
    
    originalUl.classList.add("custom-submenu-list");
    
    customSelectWrapper.appendChild(trigger);
    originalUl.parentNode.insertBefore(customSelectWrapper, originalUl);
    customSelectWrapper.appendChild(originalUl);

    trigger.addEventListener("click", function(e) {
        e.stopPropagation();
        customSelectWrapper.classList.toggle("is-open");
    });

    document.addEventListener("click", function() {
        customSelectWrapper.classList.remove("is-open");
    });
}

if (isMobile()) {
    convertSubmenuToCustomSelect();
} */

  const submenu = document.querySelector(".sub-menu");

  if (submenu) {
    submenu.style.setProperty("--height", `${submenu.scrollHeight}px`);
  
    submenu.addEventListener("click", (e) => {
      submenu.classList.toggle("active");
    });
  }

  const introDefault = document.querySelector("#intro-content-default");
  if (introDefault) {
    if (introDefault.querySelector(".sub-menu__hold .sub-menu")) {
      introDefault.classList.add("with-submenu");
    } else {
      introDefault.classList.remove("with-submenu");
    }
  }

  // (function toggleFixedSubmenuOnScroll() {
  //   const header = HEADER_EL;
  //   const hold   = document.querySelector(".sub-menu__hold");
  //   if (!header || !hold) return;

  //   const initialTop = hold.getBoundingClientRect().top + window.scrollY;
  //   window.addEventListener("scroll", function () {
  //     const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
  //     if (headerBottom >= initialTop) {
  //       if(this.document.querySelector('body.alert_open.checked')){
  //         hold.style.position = "fixed";
  //         hold.style.top = "80px";
  //       }else{
  //         hold.style.position = "fixed";
  //         hold.style.top = "145px";
  //       }
  //     } else if (window.scrollY < initialTop) {
  //       hold.style.position = "absolute";
  //       hold.style.top = "0px";
  //     }
  //   }, { passive: true });
  // })();

  // Main Nav Dropdown
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}



  	// BURGUER MENU MOBILE ----------------------------------------------------------------

	const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
	const burgerMenuContainer = document.querySelector("#js-menuContainer")
	const closeMenu = document.querySelector(".js-burger-close");
	
	//Open Menu

	if(burgerMenuBtn){
		burgerMenuBtn.addEventListener('click', function (e) {
			e.preventDefault();
			burgerMenuContainer.classList.add("open");
			document.body.classList.add("no-scroll");
		});
	}
	
	if(closeMenu){
		closeMenu.addEventListener('click', () => {
			burgerMenuContainer.classList.remove("open");
			document.body.classList.remove("no-scroll");
		});
	}


  const submenuToShow = (linksSelector, linkSubmenu) => {
  let navLinks = document.querySelectorAll(linksSelector);

  navLinks.forEach(link => {
    const parent = link.parentNode;

    link.addEventListener('click', (e) => {
      let submenu = parent.querySelector('.submenu');
      if (!submenu) return;

      const wasActive = link.classList.contains('active');

      document.querySelectorAll('.submenu.active').forEach(activeSubmenu => {
        activeSubmenu.classList.remove('active');
      });
      document.querySelectorAll(`${linksSelector}.active`).forEach(activeLink => {
        activeLink.classList.remove('active');
      });

      if (!wasActive) {
        link.classList.add('active');
        submenu.classList.add('active');
      }
    });
  });

  let submenus = document.querySelectorAll(linkSubmenu);
  submenus.forEach(sub => {
    if (sub.classList.contains('active')) {
      const depth = window.screen.width > 640 ? 3 : 4;
      let currentParent = sub;
      
      for(let i = 0; i < depth; i++) {
        if(currentParent.parentNode) currentParent = currentParent.parentNode;
      }
      
      let selectedLink = currentParent.children[0];
      if (selectedLink) selectedLink.classList.add('selected');
    }
  });
  }

  if (window.screen.width > 640) {
    submenuToShow('#primary-nav li a', '.submenu li a');
  } else {
    submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
  }


		const navItems = document.querySelectorAll('.privary-navigation__item');
		const navItemsMob = document.querySelectorAll('.mobileMenu__nav li');
		
		function addNoSubmenuClass() {
			navItems.forEach(item => {
				
				const submenu = item.querySelector('.privary-navigation__submenu');
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});
		}
		
		function addNoSubmenuMobileClass() {
			navItemsMob.forEach(item => {
				
				const submenu = item.querySelector('.sub-sub-menu');

				
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});

		}
		if(window.screen.width > 768) {
			addNoSubmenuClass();
		}else{
			addNoSubmenuMobileClass()
		}

    document.querySelectorAll('.intro-content .btn').forEach(button => {
    if (!button.querySelector('span')) {
      const text = button.textContent.trim();
      button.textContent = '';
      
      const span = document.createElement('span');
      span.textContent = text;
      button.appendChild(span);
    }
  });

  //REVIEWED home fixed group
  // if(document.querySelector('.js-home-fixed')){

  //   const homeFixed = document.querySelector('.js-home-fixed');
  //   let groupWrapper = document.createElement('div');
  //   let groupContainer = document.createElement('div');
  //   groupContainer.classList.add('group-container');
  //   groupWrapper.classList.add('group-wrapper');
  //   groupWrapper.appendChild(groupContainer);
  //   homeFixed.appendChild(groupWrapper);
  //   homeFixed.querySelectorAll('section').forEach(section => {
  //     groupContainer.appendChild(section);
  //   })


  //   if(document.querySelector('.js-home-fixed:not(:has(.no-follow))')){
  //     window.addEventListener('scroll', () => {
  //     const trackRect = homeFixed.getBoundingClientRect();
  //     const trackTop = trackRect.top;
  //     const trackHeight = 2000;
  //     const viewHeight = window.innerHeight;

  //     // Calculate percentage (0 to 1) of how far we are through the track
  //     // We start calculating when the top of the track hits the top of the viewport
  //     let progress = -trackTop / (trackHeight - viewHeight);
      
  //     // Constrain between 0 and 1
  //     progress = Math.min(Math.max(progress, 0), 1);

  //     // Move the wrapper! 
  //     // If you have 3 sections, you need to move it 200% up (0%, 100%, 200%)
  //     const moveAmount = progress * 50; 
      
  //     // Add your red background class if you still want it
  //     if (progress > 0 && progress < 1) {
  //       groupWrapper.classList.add('on-view');
  //     } else {
  //       groupWrapper.classList.remove('on-view');
  //     }
  //   });
  //   }

  



  //   const callback = (entries, observer) => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting && entry.intersectionRatio >= 1.0) {
  //         entry.target.classList.add('on-view');

  //       } else {
      
  //         entry.target.classList.remove('on-view');
      
          
          
  //       }
  //     });
  //   };
  //   const options = {
  //     root: null, 
  //     threshold: 1
  //   };
  // const observer = new IntersectionObserver(callback, options);
  // observer.observe(homeFixed);

    // const desktop = window.matchMedia("(min-width: 1024px)");

    // function initScrollEffect(){
    
    //   const sections = groupContainer.querySelectorAll('section');
    
    //   window.addEventListener('scroll', () => {
      
    //     const trackRect = homeFixed.getBoundingClientRect();
    //     const trackTop = trackRect.top;
    //     const trackHeight = 2000;
    //     const viewHeight = window.innerHeight;
      
    //     let progress = -trackTop / (trackHeight - viewHeight);
    //     progress = Math.min(Math.max(progress, 0), 1);
      
    //     const sectionProgress = progress * (sections.length - 1);
      
    //     sections.forEach((section, i) => {
        
    //       const startOffset = 0.15;
        
    //       let overlap = sectionProgress - i - startOffset;
    //       overlap = overlap / (1 - startOffset);
        
    //       if (overlap <= 0) {
    //         section.style.clipPath = "inset(0 0 0 0)";
    //       }
        
    //       else if (overlap > 0 && overlap < 1) {
    //         const clip = overlap * 100;
    //         section.style.clipPath = `inset(0 0 ${clip}% 0)`;
    //       }
        
    //       else {
    //         section.style.clipPath = "inset(0 0 100% 0)";
    //       }
        
    //     });
      
    //   });
    
    // }

    // if (desktop.matches) {
    //   initScrollEffect();
    // }

  // }



// Home stiky animation hidden-group functionality

 (() => {
  const scrollContainer = document.querySelector('.hidden-group');
  if (!scrollContainer) return;

  const contentSections = scrollContainer.querySelectorAll('section.quad');
  

  const createStickyWrapper = (target) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'hidden-group-wrapper';
    target.parentNode.insertBefore(wrapper, target);
    wrapper.appendChild(target);
    return wrapper;
  };

  const createSlidingTrack = (parent, items) => {
    const track = document.createElement('div');
    track.className = 'sections-track';
    items.forEach(item => track.appendChild(item));
    parent.appendChild(track);
    return track;
  };

  const stickyWrapper = document.querySelector('.hidden-group-wrapper') || createStickyWrapper(scrollContainer);
  const slidingTrack = scrollContainer.querySelector('.sections-track') || createSlidingTrack(scrollContainer, contentSections);

  const updateScrollAnimation = () => {
    const isMobileOrTablet = window.innerWidth <= 1024;

    if (isMobileOrTablet) {
      slidingTrack.style.transform = '';
      contentSections.forEach(section => {
        section.style.opacity = '';
        section.style.transform = '';
        section.classList.add('is-visible'); 
      });
      return;
    }

    const wrapperBounds = stickyWrapper.getBoundingClientRect();
    const viewportTriggerLine = window.innerHeight * 0.14; 

    const scrollDistance = viewportTriggerLine - wrapperBounds.top;
    
    const singleSectionHeight = contentSections[0].offsetHeight;
    const totalTrackTravel = ((contentSections.length - 0.9) * singleSectionHeight);
    const totalWrapperScrollableArea = stickyWrapper.offsetHeight - (singleSectionHeight * 0.8);

    let targetTranslateY = 0;

    if (scrollDistance > 0 && scrollDistance <= totalWrapperScrollableArea) {
      const scrollPercentage = scrollDistance / totalWrapperScrollableArea;
      targetTranslateY = scrollPercentage * totalTrackTravel;
    } else if (scrollDistance > totalWrapperScrollableArea) {
      targetTranslateY = totalTrackTravel;
    }

    // slidingTrack.style.transform = `translateY(-${targetTranslateY * 0.75}px)`;

    contentSections.forEach((section, index) => {
      const sectionPosition = index * singleSectionHeight;
      const distanceFromCenter = Math.abs(targetTranslateY - sectionPosition);
      
      if (distanceFromCenter < (singleSectionHeight * 0.65)) {
        section.classList.add('is-visible');
      } else {
        section.classList.remove('is-visible');
      }
    });
  };

  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const isDesktop = window.innerWidth > 1024;
      if (entry.isIntersecting && isDesktop) {
        window.addEventListener('scroll', updateScrollAnimation, { passive: true });
      } else {
        window.removeEventListener('scroll', updateScrollAnimation);
      }
    });
  }, { threshold: 0 });

  visibilityObserver.observe(stickyWrapper);
  
  updateScrollAnimation();
  window.addEventListener('resize', updateScrollAnimation);

  if (/iPad|iPhone|Macintosh/.test(navigator.userAgent) && navigator.vendor.includes('Apple')) {
    document.documentElement.classList.add('is-apple');
  }

})();
	
  let RFP_FORM = document.querySelector('#form_id-5111');
	if( RFP_FORM ){
		RFP_FORM.querySelector( "[name='subscribe']" ).checked = true;
		RFP_FORM.querySelector( "[name='subscribe']" ).parentNode.classList.add("hidden");
	}

});

// ------------ fixed rooms filter -------------------
const handleFilterScroll = () => {

  const filterElement = document.querySelector('.rooms__filter');

  if (!filterElement) return;
  const parentContainer = filterElement.parentElement;
  if (!parentContainer) return;

  const threshold = 80;
  const parentRect = parentContainer.getBoundingClientRect();
  const hasFixedClass = filterElement.classList.contains('fixed');

  if (parentRect.top <= threshold && !hasFixedClass) {
    filterElement.classList.add('fixed');
  } 
  else if (parentRect.top > threshold && hasFixedClass) {
    filterElement.classList.remove('fixed');
  }

};

window.addEventListener('scroll', handleFilterScroll);

document.querySelectorAll('#js-menuContainer a[href*="#"]').forEach(link => {

  link.addEventListener('click', () => {

    const menu = document.getElementById('js-menuContainer');

    if (menu) {
      menu.classList.remove('open');
    }

    document.body.classList.remove('no-scroll');

  });

});